// extracted by mini-css-extract-plugin
export default {"actions":"accountTable_actions__fCIVm","nameContainer":"accountTable_nameContainer__eLSnG"};